import React from 'react';
import withI18next from '~/../hocs/_withI18next';
import I18nLink from '~/components/I18nLink';
import themeVariables from '~/shared/themeVariables';
import Config from '~/config';

const CategoryBreadcrumb = ({ t, categoryName, pageText, page }) => {
  return (
    <ol
      className="breadcrumb"
      itemScope
      itemType="https://schema.org/BreadcrumbList"
    >
      <li
        itemProp="itemListElement"
        itemScope
        itemType="https://schema.org/ListItem"
        name={t('home_page')}
      >
        <I18nLink href="/">
          <a className="previous-link" itemProp="item" href="/">
            <span itemProp="name">{t('home_page')}</span>
          </a>
        </I18nLink>
        <meta itemProp="position" content="1" />
      </li>

      <span className="separator">{'>'}</span>
      {categoryName ? (
        <li
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
          name={t('all_categories')}
        >
          <I18nLink href="/categories">
            <a className="previous-link" itemProp="item" href="/categories">
              <span itemProp="name">{t('all_categories')}</span>
            </a>
          </I18nLink>
          <meta itemProp="position" content="2" />
        </li>
      ) : (
        <li
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
          name={t('all_categories')}
        >
          <a itemProp="item">
            <span itemProp="name"> {t('all_categories')}</span>
          </a>
          <meta itemProp="position" content="2" />
        </li>
      )}
      {categoryName && <span className="separator">{'>'}</span>}

      {categoryName && (!page || page < 2) && (
        <li
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
          name={t(Config.getPrefixContent('breadcrumb_category'), {
            nameCategory: categoryName,
          })}
        >
          <a itemProp="item">
            <span itemProp="name">
              {' '}
              {t(Config.getPrefixContent('breadcrumb_category'), {
                nameCategory: categoryName,
              })}
            </span>
          </a>
          <meta itemProp="position" content="3" />
        </li>
      )}
      {categoryName && page >= 2 && (
        <li
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
          name={
            t(Config.getPrefixContent('breadcrumb_category'), {
              nameCategory: categoryName,
            }) +
            ' ' +
            pageText
          }
        >
          <a itemProp="item">
            <span itemProp="name">
              <h1>
                {t(Config.getPrefixContent('breadcrumb_category'), {
                  nameCategory: categoryName,
                }) +
                  ' ' +
                  pageText}
              </h1>
            </span>
          </a>
          <meta itemProp="position" content="3" />
        </li>
      )}
      <style jsx>
        {`
          .breadcrumb {
            display: flex;
            flex-directoin: row;
            align-items: center;
            font-size: 16px;
            font-weight: 600;
            margin: 0;
            padding: 0;
            white-space: nowrap;
            background-color: transparent;
          }

          .previous-link {
            color: ${themeVariables.colors.link};
          }

          .previous-link:hover span {
            text-decoration: underline;
          }

          .breadcrumb a:not(.previous-link) {
            color: #000000;
            cursor: unset;
          }

          .separator {
            margin: 0 4px;
          }
          h1 {
            font-size: 16px;
            margin: 0;
          }
          @media (max-width: ${themeVariables.breakpoints.mobile.maxWidth}px) {
            .breadcrumb {
              font-size: 16px;
              flex-wrap: wrap;
            }
          }
        `}
      </style>
    </ol>
  );
};

export default withI18next()(CategoryBreadcrumb);
